import React, { FunctionComponent } from "react";

import { LegendItem } from "../../Styled/LegendItem";
import { GoogleMapsMarker } from "../../../../Common/GoogleMapsMarker/GoogleMapsMarker";
import { BrandLogoSmall } from "../BrandLogo/BrandLogoSmall";

interface RetailMatchMapLegendProps {
  brandLogo: string;
  brandName: string;
}

const defaultIconSize = {
    height: "30px",
    width: "30px",
};

export const RetailMatchMapLegend: FunctionComponent<RetailMatchMapLegendProps>
  = (props: RetailMatchMapLegendProps) => {
      return (
          <div
              style={{
                  width: "100%",
                  textAlign: "center",
                  marginTop: "8px",
              }}
          >
              <LegendItem>
                  <GoogleMapsMarker /> Target Site
              </LegendItem>
              <LegendItem>
                  <BrandLogoSmall
                      brandLogo={props.brandLogo}
                      brandName={props.brandName}
                  />{" "}
          Locations
              </LegendItem>
              <LegendItem>
                  <div
                      style={{
                          ...defaultIconSize,
                          display: "inline-block",
                          backgroundColor: "#8effa3",
                          position: "relative",
                          top: "9px",
                      }}
                  ></div>{" "}
          Trade Area
              </LegendItem>
          </div>
      );
  };
